"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _framerMotion = require("framer-motion"); // TODO experiment with fixed positioning
// make it independent component, make the offset prop


var Wrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      nav = _ref$theme.nav;
  return {
    position: 'absolute',
    top: nav.height,
    left: 0,
    width: '100%',
    minHeight: "calc(100vh - ".concat(nav.height, ")"),
    color: colors.white,
    zIndex: 100,
    backdropFilter: 'blur(2px)',
    backgroundColor: nav.backdropColor
  };
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;